// extracted by mini-css-extract-plugin
export default {"div_logo":"navbar_div_logo__P1HAD","header-title-text":"navbar_header-title-text__VKjtW"};